module.exports = __webpack_public_path__ + "img/jm.8a8dbeed.svg";